import styled from '@emotion/styled';

export const SectionHeader = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const SectionBody = styled('div')(({ theme }) => ({
  marginTop: theme.spacing[24],
  minWidth: 0,
}));

export const LoadingState = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: `${theme.spacing[24]}px 0`,
}));
